// 按照不同 API Server 的 response 狀態判斷

export const FUNLIDAY_STATUS = {
  SUCCESS: '200',
  NO_RESULTS: '204'
};

export const JOURNAL_STATUS = {
  SUCCESS: 1,
  NO_RESULTS: 4
};

export const POI_BANK_STATUS = {
  SUCCESS: 1,
  NO_RESULTS: 4
};

export const EC_STATUS = {
  SUCCESS_CODE: 1,
  NO_RESULTS: 4,
  SUCCESS_MSG: 'success'
};

export const RESPONSE_CONTENT_CODE = {
  SUCCESS: 1,
  NO_RESULTS: 4
};

export const CODE_MESSAGE = {
  SUCCESS: 'success',
  NO_RESULTS: 'no results'
};

/**
 * @typedef {Object.<string>} ITINERARY_SQUAWK
 * @readonly
 * @param {string} ITINERARY_SQUAWK.OKAY - 200 OK
 * @param {string} ITINERARY_SQUAWK.PXY_OKAY - 203 Proxy OK; Non-Authoritative Information
 * @param {string} ITINERARY_SQUAWK.TOKEN_UNAVAILABLE - 603 Edit token is not available, client refresh is required
 * @param {string} ITINERARY_SQUAWK.EDIT_CONFLICT - 605 Version conflicts
 * @param {string} ITINERARY_SQUAWK.PRIVATE_ITIN - 607 The Itinerary is private
 * @param {string} ITINERARY_SQUAWK.SOCKET_TIMEOUT - 646 Socket timeout, client refresh is required
 */
export const ITINERARY_SQUAWK = Object.freeze({
  OKAY: '200',
  PXY_OKAY: '203',
  TOKEN_UNAVAILABLE: '603',
  EDIT_CONFLICT: '605',
  PRIVATE_ITIN: '607',
  SOCKET_TIMEOUT: '646'
});
